(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pebble-collective-slider"] && !Shopify.designMode) return;
  try {
    
  class PebbleCollectiveSlider extends HTMLElement {
    static AUTOPLAY_DELAY = 2000;

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.collective-slider__tab'));
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.description = this.querySelector('.collective-slider__description');
      this.nav = this.querySelector('.collective-slider__nav');
      this.autoplayInterval = null;

      if (!this.tabs.length || !this.slides.length) {
        return;
      }

      this.activeIndex = 0;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = Number.parseInt(tab.dataset.slideIndex, 10);
          this.setActive(index);
          this.resetAutoplay();
        });

        tab.addEventListener('keydown', (event) => {
          this.handleTabKeydown(event, tab);
        });
      });

      this.slides.forEach((slide) => {
        slide.addEventListener('click', () => {
          const index = Number.parseInt(slide.dataset.slideIndex, 10);
          this.setActive(index);
          this.resetAutoplay();
        });
      });

      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.pauseAutoplay());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) {
          this.startAutoplay();
        }
      });

      this.setActive(0);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.pauseAutoplay();
    }

    startAutoplay() {
      this.pauseAutoplay();

      this.autoplayInterval = setInterval(() => {
        const nextIndex = (this.activeIndex + 1) % this.tabs.length;
        this.setActive(nextIndex);
      }, PebbleCollectiveSlider.AUTOPLAY_DELAY);
    }

    pauseAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    resetAutoplay() {
      this.startAutoplay();
    }

    handleTabKeydown(event, tab) {
      const currentIndex = Number.parseInt(tab.dataset.slideIndex, 10);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        event.preventDefault();
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else {
        return;
      }

      this.setActive(nextIndex);
      this.tabs[nextIndex]?.focus();
      this.resetAutoplay();
    }

    setActive(index) {
      if (index < 0 || index >= this.tabs.length) {
        return;
      }

      this.activeIndex = index;

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.classList.toggle('is-active', isActive);
        slide.tabIndex = isActive ? 0 : -1;
      });

      if (this.description) {
        const descriptionText =
          this.slides[index]?.dataset.description || this.tabs[index]?.dataset.description || '';

        if (descriptionText) {
          this.description.textContent = descriptionText;
        }
      }

      this.scrollActiveTabIntoView();
    }

    scrollActiveTabIntoView() {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        return;
      }

      const activeTab = this.tabs[this.activeIndex];

      if (!this.nav || !activeTab || this.nav.scrollWidth <= this.nav.clientWidth) {
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      requestAnimationFrame(() => {
        const tabOffsetLeft = activeTab.offsetLeft;
        const tabWidth = activeTab.offsetWidth;
        const navWidth = this.nav.clientWidth;
        const targetScroll = tabOffsetLeft - (navWidth - tabWidth) / 2;
        const maxScroll = this.nav.scrollWidth - navWidth;

        this.nav.scrollTo({
          left: Math.max(0, Math.min(targetScroll, maxScroll)),
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      });
    }
  }

  if (!customElements.get('pebble-collective-slider')) {
    customElements.define('pebble-collective-slider', PebbleCollectiveSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-banner-slider"] && !Shopify.designMode) return;
  try {
    
  class Slider extends HTMLElement {
    #slider;
    #slides;
    #currentIndex;
    #autoplay;
    #autoplaySpeed;
    #loop;
    #autoplayInterval;
    #autoplayAllowed;
    #paginationDots;
    #dragState;

    #initButtons;
    #initAutoplay;
    #startAutoplay;
    #pauseAutoplay;
    #allowAutoplay;
    #waitForLcpImage;
    #initIntersectionObserver;
    #scrollToSlide;
    #updateActiveStates;
    #initPagination;
    #initDragging;
    #handleDragStart;
    #handleDragMove;
    #handleDragEnd;

    constructor() {
      super();
      this.#slider = this.querySelector('[data-slider]');
      this.#slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.#currentIndex = 0;
      
      this.#autoplay = this.dataset.autoplay === 'true';
      this.#autoplaySpeed = parseInt(this.dataset.autoplaySpeed || '5000', 10);
      this.#loop = this.dataset.loop === 'true';
      this.#autoplayAllowed = false;

      this.#dragState = {
        isDragging: false,
        startX: 0,
        currentX: 0,
        dragThreshold: 50
      };

      this.#slides[0].classList.add('is-active');

      this.#initButtons = () => {
        const prevButton = this.querySelector('[data-prev]');
        const nextButton = this.querySelector('[data-next]');
        
        if (!prevButton || !nextButton) return;

        prevButton.addEventListener('click', () => {
          this.#allowAutoplay();
          this.#scrollToSlide('prev');
          this.#startAutoplay();
        });

        nextButton.addEventListener('click', () => {
          this.#allowAutoplay();
          this.#scrollToSlide('next');
          this.#startAutoplay();
        });
      };

      this.#allowAutoplay = () => {
        if (this.#autoplayAllowed) return;
        this.#autoplayAllowed = true;
      };

      this.#waitForLcpImage = () => {
        return new Promise((resolve) => {
          const firstSlide = this.#slides[0];

          if (!firstSlide) {
            resolve();
            return;
          }

          const img = firstSlide.querySelector('img');

          if (!img) {
            requestAnimationFrame(() => resolve());
            return;
          }

          if (img.complete && img.naturalWidth > 0) {
            resolve();
            return;
          }

          const done = () => resolve();
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        });
      };

      this.#initAutoplay = async () => {
        this.#autoplayInterval = null;

        this.addEventListener('mouseenter', () => this.#pauseAutoplay());
        this.addEventListener('mouseleave', () => this.#startAutoplay());
        this.addEventListener('focusin', () => this.#pauseAutoplay());
        this.addEventListener('focusout', () => this.#startAutoplay());

        // Keep slide 1 visible until LCP image is ready, then hold one interval
        // so lab/real LCP does not jump to a later slide.
        await this.#waitForLcpImage();

        const holdMs = Math.max(this.#autoplaySpeed, 2000);
        await new Promise((resolve) => setTimeout(resolve, holdMs));

        if (!this.isConnected) return;

        this.#allowAutoplay();
        this.#startAutoplay();
      };

      this.#startAutoplay = () => {
        if (!this.#autoplay || !this.#autoplayAllowed) {
          return;
        }
        this.#pauseAutoplay();
        this.#autoplayInterval = setInterval(() => {
          this.#scrollToSlide('next');
        }, this.#autoplaySpeed);
      };

      this.#pauseAutoplay = () => {
        if (this.#autoplayInterval) {
          clearInterval(this.#autoplayInterval);
          this.#autoplayInterval = null;
        }
      };

      this.#initIntersectionObserver = () => {
        let pausedByObserver = false;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (pausedByObserver) {
                this.#startAutoplay();
                pausedByObserver = false;
              }
              const images = entry.target.querySelectorAll('[loading="lazy"]');
              images.forEach(img => {
                if (img.dataset.src) {
                  img.src = img.dataset.src;
                  delete img.dataset.src;
                }
              });
            } else {
              if (this.#autoplayInterval) pausedByObserver = true;
              this.#pauseAutoplay();
            }
          });
        }, { threshold: 0.1 });

        observer.observe(this);
      };

      this.#scrollToSlide = (target) => {
        let targetIndex;

        if (target === 'next') {
          targetIndex = this.#currentIndex + 1;
        } else if (target === 'prev') {
          targetIndex = this.#currentIndex - 1;
        } else {
          targetIndex = target;
        }

        if (this.#loop) {
          if (targetIndex >= this.#slides.length) {
            targetIndex = 0;
          } else if (targetIndex < 0) {
            targetIndex = this.#slides.length - 1;
          }
        } else {
          targetIndex = Math.max(0, Math.min(targetIndex, this.#slides.length - 1));
        }

        if (targetIndex === this.#currentIndex) return;

        this.#slides[this.#currentIndex].classList.remove('is-active');
        
        this.#currentIndex = targetIndex;
        
        this.#slides[this.#currentIndex].classList.add('is-active');

        this.#updateActiveStates();

        if (this.#autoplayInterval) {
          this.#startAutoplay();
        }
      };

      this.#initPagination = () => {
        this.#paginationDots = Array.from(this.querySelectorAll('.pagination-dot'));

        if (!this.#paginationDots.length) return;

        this.#paginationDots.forEach(dot => {
          dot.addEventListener('click', () => {
            const index = parseInt(dot.dataset.slideIndex);
            this.#allowAutoplay();
            this.#scrollToSlide(index);
            this.#startAutoplay();
          });
        });
      };

      this.#updateActiveStates = () => {
        this.#slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === this.#currentIndex);
          slide.setAttribute('aria-hidden', index !== this.#currentIndex);
        });

        if (this.#paginationDots.length) {
          this.#paginationDots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === this.#currentIndex);
            dot.setAttribute('aria-current', index === this.#currentIndex);
          });
        }

        if (!this.#loop) {
          const prevButton = this.querySelector('[data-prev]');
          const nextButton = this.querySelector('[data-next]');
          
          if (prevButton) prevButton.disabled = this.#currentIndex === 0;
          if (nextButton) nextButton.disabled = this.#currentIndex === this.#slides.length - 1;
        }

        this.dispatchEvent(new CustomEvent('slide-change', {
          detail: { currentIndex: this.#currentIndex }
        }));
      };

      this.#initDragging = () => {
        this.#slider.addEventListener('mousedown', (e) => this.#handleDragStart(e));
        document.addEventListener('mousemove', (e) => this.#handleDragMove(e));
        document.addEventListener('mouseup', (e) => this.#handleDragEnd(e));
        
        this.#slider.addEventListener('touchstart', (e) => this.#handleDragStart(e), { passive: true });
        this.#slider.addEventListener('touchmove', (e) => this.#handleDragMove(e), { passive: false });
        document.addEventListener('touchend', (e) => this.#handleDragEnd(e));

        this.#slider.addEventListener('dragstart', (e) => e.preventDefault());
      };

      this.#handleDragStart = (e) => {
        this.#dragState.isDragging = true;
        this.#dragState.startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
        this.#dragState.currentX = this.#dragState.startX;
        
        this.#pauseAutoplay();
        
        this.#slider.style.cursor = 'grabbing';
      };

      this.#handleDragMove = (e) => {
        if (!this.#dragState.isDragging) return;
        
        this.#dragState.currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
        const dragDistance = Math.abs(this.#dragState.currentX - this.#dragState.startX);
        
        if (dragDistance > 10 && e.cancelable) {
          e.preventDefault();
        }
      };

      this.#handleDragEnd = (e) => {
        if (!this.#dragState.isDragging) return;
        
        const dragDistance = this.#dragState.currentX - this.#dragState.startX;

        if (Math.abs(dragDistance) > this.#dragState.dragThreshold) {
          this.#allowAutoplay();
          if (dragDistance > 0) {
            this.#scrollToSlide('prev');
          } else {
            this.#scrollToSlide('next');
          }
        }
        
        this.#dragState.isDragging = false;
        this.#dragState.startX = 0;
        this.#dragState.currentX = 0;
        
        this.#slider.style.cursor = '';
        
        this.#startAutoplay();
      };

      this.init();
    }

    init() {
      this.#initButtons();
      this.#initPagination();
      this.#initDragging();
      this.#initIntersectionObserver();

      if (this.#autoplay) {
        if (document.readyState === 'complete') {
          this.#initAutoplay();
        } else {
          window.addEventListener('load', () => this.#initAutoplay(), { once: true });
        }
      }
    }
  }

  customElements.define('slider-components', Slider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-chat-popup"] && !Shopify.designMode) return;
  try {
    
class SdChatPopup extends HTMLElement {
  /** @type {HTMLDialogElement | null} */
  #dialog = null;

  /** @type {HTMLButtonElement | null} */
  #trigger = null;

  /** @type {HTMLButtonElement | null} */
  #closeButton = null;

  /** @type {string} */
  #previousOverflow = '';

  /** @type {number} */
  #bubbleTimer = 0;

  connectedCallback() {
    this.#dialog = this.querySelector('[data-chat-dialog]');
    this.#trigger = this.querySelector('[data-chat-open]');
    this.#closeButton = this.querySelector('[data-chat-close]');

    if (!this.#dialog || !this.#trigger || !this.#closeButton) return;

    this.#trigger.addEventListener('click', this.#open);
    this.#closeButton.addEventListener('click', this.#close);
    this.#dialog.addEventListener('click', this.#handleBackdrop);
    this.#dialog.addEventListener('cancel', this.#handleCancel);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', this.#handleSectionSelect);
      document.addEventListener('shopify:section:deselect', this.#handleSectionDeselect);
    }

    this.#bubbleTimer = window.setTimeout(this.#revealBubble, 1000);
  }

  disconnectedCallback() {
    window.clearTimeout(this.#bubbleTimer);
    this.#trigger?.removeEventListener('click', this.#open);
    this.#closeButton?.removeEventListener('click', this.#close);
    this.#dialog?.removeEventListener('click', this.#handleBackdrop);
    this.#dialog?.removeEventListener('cancel', this.#handleCancel);
    document.removeEventListener('shopify:section:select', this.#handleSectionSelect);
    document.removeEventListener('shopify:section:deselect', this.#handleSectionDeselect);
    this.#unlockScroll();
  }

  #revealBubble = () => {
    if (!this.querySelector('.sd-chat-popup__bubble')) return;

    this.classList.add('sd-chat-popup--bubble-in');
    this.#bubbleTimer = window.setTimeout(this.#dismissBubble, 3000);
  };

  #dismissBubble = () => {
    this.classList.add('sd-chat-popup--bubble-dismissed');
    this.classList.remove('sd-chat-popup--bubble-in');
  };

  #open = () => {
    if (!this.#dialog || this.#dialog.open) return;

    this.#previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    this.#dialog.showModal();
    this.#trigger?.setAttribute('aria-expanded', 'true');
    this.classList.add('sd-chat-popup--open');
    this.#closeButton?.focus();
  };

  #close = () => {
    if (!this.#dialog || !this.#dialog.open) return;

    this.#dialog.close();
    this.#trigger?.setAttribute('aria-expanded', 'false');
    this.classList.remove('sd-chat-popup--open');
    this.#unlockScroll();
    this.#trigger?.focus();
  };

  #unlockScroll() {
    document.documentElement.style.overflow = this.#previousOverflow;
  }

  /**
   * @param {MouseEvent} event
   */
  #handleBackdrop = (event) => {
    if (event.target === this.#dialog) this.#close();
  };

  /**
   * @param {Event} event
   */
  #handleCancel = (event) => {
    event.preventDefault();
    this.#close();
  };

  /**
   * @param {Event} event
   */
  #handleSectionSelect = (event) => {
    const detail = /** @type {CustomEvent} */ (event).detail;
    if (detail?.sectionId === this.dataset.sectionId) this.#open();
  };

  /**
   * @param {Event} event
   */
  #handleSectionDeselect = (event) => {
    const detail = /** @type {CustomEvent} */ (event).detail;
    if (detail?.sectionId === this.dataset.sectionId) this.#close();
  };
}

if (!customElements.get('sd-chat-popup')) {
  customElements.define('sd-chat-popup', SdChatPopup);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-popup"] && !Shopify.designMode) return;
  try {
    
  class SdPopup extends HTMLElement {
    #dialog;
    #closeButton;
    #sectionId;
    #delay;
    #showTimeout;
    #cookieName;
    #cookieMaxAge = 1800; /* 30 minutes in seconds */

    connectedCallback() {
      this.#dialog = this.querySelector('[data-popup-dialog]');
      this.#closeButton = this.querySelector('[data-popup-close]');
      this.#sectionId = this.dataset.sectionId;
      this.#delay = parseInt(this.dataset.delay || '600', 10);
      this.#cookieName = `sd_popup_dismissed_${this.#sectionId}`;

      if (!this.#dialog || !this.#closeButton) return;

      this.#closeButton.addEventListener('click', () => this.close());

      /* Close when clicking the backdrop (outside the content) */
      this.#dialog.addEventListener('click', (event) => {
        if (event.target === this.#dialog) this.close();
      });

      /* Native dialog closes on Escape — sync our cookie/event logic */
      this.#dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      if (window.Shopify && window.Shopify.designMode) {
        this.#initDesignMode();
        return;
      }

      if (this.#isDismissed()) return;

      this.#showTimeout = setTimeout(() => this.open(), this.#delay);
    }

    disconnectedCallback() {
      clearTimeout(this.#showTimeout);
    }

    open() {
      if (this.#dialog.open) return;
      this.#dialog.showModal();
    }

    close() {
      if (!this.#dialog.open) return;
      this.#dialog.close();

      if (!(window.Shopify && window.Shopify.designMode)) {
        this.#setDismissedCookie();
      }

      /* Hook for external code: listen for `sd-popup:closed` on document */
      this.dispatchEvent(
        new CustomEvent('sd-popup:closed', {
          bubbles: true,
          detail: { sectionId: this.#sectionId },
        })
      );
    }

    #isDismissed() {
      return document.cookie
        .split('; ')
        .some((cookie) => cookie.startsWith(`${this.#cookieName}=`));
    }

    #setDismissedCookie() {
      document.cookie = `${this.#cookieName}=1; max-age=${this.#cookieMaxAge}; path=/; SameSite=Lax`;
    }

    #initDesignMode() {
      /* In the theme editor, show the popup when its section is selected */
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.#sectionId) this.open();
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.#sectionId && this.#dialog.open) {
          this.#dialog.close();
        }
      });

      this.open();
    }
  }

  if (!customElements.get('sd-popup-component')) {
    customElements.define('sd-popup-component', SdPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
